// extracted by mini-css-extract-plugin
export default {"more":"ListComponent_more_QqqLE","expanded":"ListComponent_expanded_BHRgw"};